function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _g;
var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};
var SvgMeetingRoom = function SvgMeetingRoom(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '35px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '35px' : _ref$height,
    originalSize = _ref.originalSize,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#494949",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M18.73 34c0 .552.553 1 0 1H7a1 1 0 0 1-.863-1.504l9.929-17a1 1 0 0 1 .863-.496h14.547a1 1 0 0 1 .872.511l9.524 17A1 1 0 0 1 41 35H29.378c-.552 0 0-.448 0-1H41l-9.524-17H16.929L7 34h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M19 23v12h10V23H19Zm0-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1V23a1 1 0 0 1 1-1Zm4.697 18.843-4.853 3.695a.5.5 0 1 0 .606.795l4.853-3.694a.5.5 0 0 0-.606-.796Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "m23.708 41.74 4.89 3.518a.5.5 0 1 0 .583-.812l-4.889-3.518a.5.5 0 1 0-.584.812Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M26.5 25h-5a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1Zm0 3h-5a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1Zm0 3h-5a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1Zm3 6h-11a.5.5 0 1 0 0 1h11a.5.5 0 1 0 0-1Zm9-2v11.05a.5.5 0 1 0 1 0V35a.5.5 0 1 0-1 0Zm-31 0v11.05a.5.5 0 1 0 1 0V35a.5.5 0 1 0-1 0Zm-.81-11.257h5.439a1 1 0 0 0 .852-.477l2.669-4.354a1 1 0 0 0-.853-1.522H11V11a1 1 0 0 0-1.574-.82l-3.701 2.593a1 1 0 0 0-.427.819v5.91c0 .553 1 0 1 0v-5.91L10 11v7.39h4.797l-2.668 4.353h-5.44s-.552 1 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.572 26.39a1 1 0 0 1 .875 1.485l-2.42 4.354a1 1 0 0 1-.873.514H2.298a1 1 0 0 1-1-1v-9.151a1 1 0 0 1 .427-.82l3.701-2.591A1 1 0 0 1 7 20v6.39h2.572ZM6 20l-3.702 2.592v9.151h4.856l2.418-4.353H6V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3 32.5v4.123a.5.5 0 1 0 1 0V32.5a.5.5 0 1 0-1 0Zm39.287-9.757a1 1 0 0 1-1 1h-5.302a1 1 0 0 1-.886-.535l-2.283-4.354a1 1 0 0 1 .886-1.464h3.411V11a1 1 0 0 1 1.574-.82l3.702 2.593a1 1 0 0 1 .426.819v5.454a1 1 0 0 1-1.141.99l.141-.99v-5.454L38.113 11v7.39h-4.642l2.514 4.353h5.302l.141-.99a1 1 0 0 1 .859.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M42.274 20v7.39h-3.572l2.419 4.353h4.855v-9.151L42.274 20Zm-1 0a1 1 0 0 1 1.574-.82l3.702 2.593a1 1 0 0 1 .426.819v9.151a1 1 0 0 1-1 1h-4.855a1 1 0 0 1-.874-.514l-2.42-4.354a1 1 0 0 1 .875-1.485h2.572V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M44 32.5v4.123a.5.5 0 1 0 1 0V32.5a.5.5 0 1 0-1 0ZM26.5 40h12a.5.5 0 1 0 0-1h-12a.5.5 0 1 0 0 1Zm-18 0h12a.5.5 0 1 0 0-1h-12a.5.5 0 1 0 0 1Zm8-28.5h15v-7h-15v7Zm-.5-8h16a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H16a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5Zm7.5 32v9.475a.5.5 0 1 0 1 0V35.5a.5.5 0 1 0-1 0Z"
  }))));
};
export { SvgMeetingRoom as ReactComponent };
export default "/_next/static/media/meeting_room.80961c7c.svg";